import React from "react";
import LegalPage from "@/components/legal/LegalPage";
import { termsContent } from "@/content/legal/terms";

export default function Terms() {
  return (
    <LegalPage
      titleKey="public.terms.title"
      updatedKey="public.lastUpdated"
      metaDescriptionKey="public.terms.meta"
      sectionsByLang={termsContent}
      testId="page-terms"
    />
  );
}
